import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PageSEO from "@/components/PageSEO";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageSEO
        title="Privacy Policy | Marquetta Bryant"
        description="How marquettabryant.com collects, uses, and protects your personal information."
        canonical="https://marquettabryant.com/privacy-policy"
      />
      <Header />
      <main className="pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <h1 className="text-3xl md:text-4xl font-bold mb-8">Privacy Policy</h1>
            <p className="text-muted-foreground mb-6">Last updated: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">1. Information We Collect</h2>
            <p className="text-muted-foreground mb-4">We collect information you provide directly, including your name, email address, phone number, and any other details submitted through forms on our website such as registration, newsletter sign-up, or speaking inquiry forms.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">2. How We Use Your Information</h2>
            <p className="text-muted-foreground mb-4">Your information is used to:</p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2 mb-4">
              <li>Process event registrations and payments</li>
              <li>Send newsletters, updates, and marketing communications</li>
              <li>Respond to speaking and partnership inquiries</li>
              <li>Improve our website and services</li>
            </ul>

            <h2 className="text-xl font-semibold mt-10 mb-4">3. Information Sharing</h2>
            <p className="text-muted-foreground mb-4">We do not sell or rent your personal information to third parties. We may share information with trusted service providers who assist in operating our website, processing payments, or delivering services on our behalf.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">4. Data Security</h2>
            <p className="text-muted-foreground mb-4">We implement reasonable security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">5. Cookies</h2>
            <p className="text-muted-foreground mb-4">Our website may use cookies and similar technologies to enhance your browsing experience and analyze site traffic.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">6. Your Rights</h2>
            <p className="text-muted-foreground mb-4">You may request access to, correction of, or deletion of your personal data by contacting us directly.</p>

            <h2 className="text-xl font-semibold mt-10 mb-4">7. Contact</h2>
            <p className="text-muted-foreground mb-4">For privacy-related questions, please reach out via our Contact page or email us directly.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
